import React, { useState, useEffect } from 'react';
import { showError } from '../utils/alertas';

const IS_PROD = true;
const API_BASE_URL = IS_PROD ? 'https://sigoapi.jhe-etes.com.br/api' : 'http://localhost:3001/api';

function TelemetriaModal({ isOpen, onClose }) {
    const [loading, setLoading] = useState(true);
    const [stats, setStats] = useState({
        total_geral: 0,
        ete_campea: 'N/A',
        ete_campea_acessos: 0,
        visao_geral_count: 0,
        contratos_count: 0,
        ranking: []
    });

    useEffect(() => {
        if (!isOpen) return;

        const fetchStats = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem('token');
                const response = await fetch(`${API_BASE_URL}/telemetria/estatisticas`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                if (response.ok) {
                    const data = await response.json();
                    setStats(data);
                } else {
                    showError("Erro", "Não foi possível carregar as métricas de telemetria.");
                }
            } catch (error) {
                console.error("❌ Erro ao buscar telemetria:", error);
                showError("Erro de Conexão", "Falha ao conectar com o servidor.");
            } finally {
                setLoading(false);
            }
        };

        fetchStats();
    }, [isOpen]);

    if (!isOpen) return null;

    // Cálculo dos percentuais de preferência
    const totalAbas = (stats.visao_geral_count || 0) + (stats.contratos_count || 0);
    const pctVisaoGeral = totalAbas > 0 ? Math.round((stats.visao_geral_count / totalAbas) * 100) : 50;
    const pctContratos = totalAbas > 0 ? Math.round((stats.contratos_count / totalAbas) * 100) : 50;

    // Maior número de acessos do ranking para calcular barra do mapa de calor
    const maxAcessosRanking = stats.ranking && stats.ranking.length > 0 ? stats.ranking[0].total_acessos : 1;

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-sm p-3 sm:p-4 animate-fadeIn">
            <div className="bg-white rounded-3xl sm:rounded-[2rem] shadow-2xl w-full max-w-4xl max-h-[92vh] sm:max-h-[90vh] overflow-hidden flex flex-col border border-white/20">
                
                {/* ── CABEÇALHO ───────────────────────────────────────── */}
                <div className="bg-slate-900 text-white px-5 sm:px-8 py-4 sm:py-6 flex justify-between items-center shrink-0">
                    <div>
                        <h2 className="text-lg sm:text-xl font-black tracking-tight flex items-center gap-2">
                            <span>📊</span> Telemetria & Analytics
                        </h2>
                        <p className="text-[10px] sm:text-xs text-blue-200/80 font-medium mt-0.5">
                            Métricas de engajamento, ETEs mais acessadas e comportamento dos usuários.
                        </p>
                    </div>
                    <button
                        onClick={onClose}
                        className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/10 text-white/70 hover:text-white transition-all text-xl font-bold shrink-0"
                    >
                        ✕
                    </button>
                </div>

                {/* ── CORPO DO DASHBOARD ─────────────────────────────── */}
                <div className="p-4 sm:p-8 overflow-y-auto custom-scrollbar space-y-6 sm:space-y-8 bg-slate-50/50 flex-1">
                    
                    {loading ? (
                        <div className="py-20 flex flex-col items-center justify-center gap-4">
                            <div className="w-10 h-10 border-4 border-sabesp-cyan border-t-transparent rounded-full animate-spin"></div>
                            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest">Carregando telemetria em tempo real...</p>
                        </div>
                    ) : (
                        <>
                            {/* ── 1. CARDS DE MÉTRICAS GERAIS ──────────────────── */}
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                {/* Total Visualizações */}
                                <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                                    <div className="flex items-center gap-3 mb-3">
                                        <div className="w-10 h-10 rounded-2xl bg-blue-50 text-sabesp-blue flex items-center justify-center text-xl font-bold">
                                            👁️
                                        </div>
                                        <div>
                                            <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Visualizações Gerais</span>
                                            <p className="text-2xl font-black text-slate-800 leading-none mt-1">{stats.total_geral}</p>
                                        </div>
                                    </div>
                                    <p className="text-[11px] text-gray-400 font-medium border-t border-gray-50 pt-2">Total acumulado de navegações</p>
                                </div>

                                {/* ETE Campeã */}
                                <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                                    <div className="flex items-center gap-3 mb-3">
                                        <div className="w-10 h-10 rounded-2xl bg-amber-50 text-amber-500 flex items-center justify-center text-xl font-bold">
                                            🏆
                                        </div>
                                        <div className="truncate">
                                            <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">ETE Campeã do Mês</span>
                                            <p className="text-base font-black text-slate-800 truncate leading-tight mt-1" title={stats.ete_campea}>{stats.ete_campea}</p>
                                        </div>
                                    </div>
                                    <p className="text-[11px] text-emerald-600 font-bold border-t border-gray-50 pt-2 flex justify-between">
                                        <span>🔥 Liderança em acessos</span>
                                        <span>{stats.ete_campea_acessos} visitas</span>
                                    </p>
                                </div>

                                {/* Preferência de Conteúdo */}
                                <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                                    <div className="flex items-center gap-3 mb-3">
                                        <div className="w-10 h-10 rounded-2xl bg-cyan-50 text-sabesp-cyan flex items-center justify-center text-xl font-bold">
                                            💡
                                        </div>
                                        <div>
                                            <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Preferência de Conteúdo</span>
                                            <p className="text-sm font-black text-slate-800 leading-tight mt-1">
                                                {pctVisaoGeral >= pctContratos ? 'Visão Geral' : 'Contratos & Execução'}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="border-t border-gray-50 pt-2 flex justify-between text-[11px] font-bold">
                                        <span className="text-sabesp-blue">Visão Geral: {pctVisaoGeral}%</span>
                                        <span className="text-purple-600">Contratos: {pctContratos}%</span>
                                    </div>
                                </div>
                            </div>

                            {/* ── 2. RANKING E MAPA DE CALOR ───────────────────── */}
                            <div className="bg-white p-8 rounded-3xl border border-gray-100 shadow-sm space-y-6">
                                <div className="flex justify-between items-center">
                                    <div>
                                        <h3 className="text-base font-black text-slate-800 flex items-center gap-2">
                                            <span>🔥</span> Ranking de ETEs Mais Acessadas (Mapa de Calor)
                                        </h3>
                                        <p className="text-xs text-gray-400 font-medium">Top 10 empreendimentos com maior volume de buscas e acessos</p>
                                    </div>
                                    <span className="text-[10px] font-bold text-sabesp-blue bg-blue-50 px-3 py-1 rounded-full uppercase tracking-wider">
                                        Top 10 ETEs
                                    </span>
                                </div>

                                {stats.ranking.length === 0 ? (
                                    <div className="py-12 text-center text-gray-400 text-xs font-medium">
                                        Nenhum registro de visualização acumulado até o momento.
                                    </div>
                                ) : (
                                    <div className="space-y-4">
                                        {stats.ranking.map((ete, idx) => {
                                            const pctBarra = Math.max(8, Math.round((ete.total_acessos / maxAcessosRanking) * 100));
                                            const pctRelativa = stats.total_geral > 0 ? ((ete.total_acessos / stats.total_geral) * 100).toFixed(1) : 0;

                                            return (
                                                <div key={ete.id || idx} className="space-y-1.5">
                                                    <div className="flex justify-between items-center text-xs font-bold">
                                                        <div className="flex items-center gap-2">
                                                            <span className={`w-5 h-5 rounded-full text-[10px] flex items-center justify-center font-black ${
                                                                idx === 0 ? 'bg-amber-400 text-white' : idx === 1 ? 'bg-slate-300 text-slate-700' : idx === 2 ? 'bg-amber-600 text-white' : 'bg-gray-100 text-gray-500'
                                                            }`}>
                                                                {idx + 1}
                                                            </span>
                                                            <span className="text-slate-800 font-extrabold">{ete.nome}</span>
                                                            {ete.nome_municipio && (
                                                                <span className="text-[10px] text-gray-400 font-medium">📍 {ete.nome_municipio}</span>
                                                            )}
                                                        </div>
                                                        <div className="flex items-center gap-3">
                                                            <span className="text-sabesp-blue font-black">{ete.total_acessos} acessos</span>
                                                            <span className="text-[10px] text-gray-400 font-semibold w-12 text-right">({pctRelativa}%)</span>
                                                        </div>
                                                    </div>

                                                    {/* Barra de Progresso Mapa de Calor */}
                                                    <div className="w-full h-3 bg-slate-100 rounded-full overflow-hidden p-0.5 shadow-inner">
                                                        <div
                                                            className="h-full rounded-full bg-gradient-to-r from-sabesp-blue via-sabesp-cyan to-emerald-400 transition-all duration-1000 shadow-sm"
                                                            style={{ width: `${pctBarra}%` }}
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>

                            {/* ── 3. DISTRIBUIÇÃO DE COMPORTAMENTO ────────────── */}
                            <div className="bg-white p-8 rounded-3xl border border-gray-100 shadow-sm space-y-4">
                                <div>
                                    <h3 className="text-base font-black text-slate-800 flex items-center gap-2">
                                        <span>🧩</span> Comportamento de Navegação (Abas Internas)
                                    </h3>
                                    <p className="text-xs text-gray-400 font-medium">Proporção de interesse dos usuários entre informações gerais e dados contratuais</p>
                                </div>

                                <div className="space-y-3 pt-2">
                                    {/* Barra Comparativa Única */}
                                    <div className="w-full h-6 bg-slate-100 rounded-2xl overflow-hidden flex shadow-inner">
                                        <div
                                            className="bg-sabesp-blue h-full transition-all duration-1000 flex items-center justify-center text-[10px] font-black text-white"
                                            style={{ width: `${pctVisaoGeral}%` }}
                                            title={`Visão Geral: ${pctVisaoGeral}%`}
                                        >
                                            {pctVisaoGeral > 15 && `Visão Geral (${pctVisaoGeral}%)`}
                                        </div>
                                        <div
                                            className="bg-purple-600 h-full transition-all duration-1000 flex items-center justify-center text-[10px] font-black text-white"
                                            style={{ width: `${pctContratos}%` }}
                                            title={`Contratos e Execução: ${pctContratos}%`}
                                        >
                                            {pctContratos > 15 && `Contratos (${pctContratos}%)`}
                                        </div>
                                    </div>

                                    <div className="flex justify-between items-center text-xs font-bold pt-1">
                                        <div className="flex items-center gap-2 text-sabesp-blue">
                                            <span className="w-3 h-3 bg-sabesp-blue rounded-full"></span>
                                            <span>Visão Geral: {stats.visao_geral_count} acessos</span>
                                        </div>
                                        <div className="flex items-center gap-2 text-purple-600">
                                            <span className="w-3 h-3 bg-purple-600 rounded-full"></span>
                                            <span>Contratos & Execução: {stats.contratos_count} acessos</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>

                {/* ── RODAPÉ ─────────────────────────────────────────── */}
                <div className="bg-slate-50 px-8 py-4 border-t border-gray-100 flex justify-end shrink-0">
                    <button
                        onClick={onClose}
                        className="px-6 py-2.5 bg-slate-800 text-white font-bold rounded-xl hover:bg-slate-900 transition-all text-xs uppercase tracking-wider shadow-sm"
                    >
                        Fechar Painel
                    </button>
                </div>
            </div>
        </div>
    );
}

export default TelemetriaModal;
